export default __webpack_public_path__ + "static/media/home-page-header-2.01c71472.png";